import React, { Dispatch, SetStateAction } from "react";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Button } from "@mui/material";

import styles from "./BackNextButtons.module.scss";

const BackNextButtons: React.FC<{
  step: number;
  disabledNext?: boolean;
  stepLength: number;
  setStep: Dispatch<SetStateAction<number>>;
  onSubmitFinal: () => void;
}> = ({ step, setStep, stepLength, disabledNext, onSubmitFinal }) => {
  const handleBack = () => setStep(prevStep => prevStep - 1);
  const handleNext = () => {
    setStep(prev => {
      const isLast = prev >= stepLength;
      if (isLast) {
        onSubmitFinal();
        return prev;
      }
      return prev + 1;
    });
  };
  const isLastStep = step === stepLength;
  return (
    <div className={styles.container}>
      <Button
        onClick={handleBack}
        disabled={step === 1}
        variant="outlined"
        type="button"
        startIcon={<ArrowBackIcon />}
      >
        Back
      </Button>
      <Button
        onClick={handleNext}
        variant="contained"
        type="button"
        endIcon={<ArrowForwardIcon />}
        disabled={disabledNext}
      >
        {isLastStep ? "Submit" : "Next"}
      </Button>
    </div>
  );
};

export default BackNextButtons;
